<template>
  <div>
    <!-- 3แยก -->
    <b-card
      v-if="check < 4"
      class="hero1"
      style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;"
    >
      <b-row
        align-h="between"
        class="hero2"
      >
        <b-col
          v-for="(item, index) in count.slice(0,2)"
          :key="index"
          lg="3"
          md="6"
          sm="12"
        >
          <video
            :id="'count' + (index)"
            style="width:100%;"
            muted
            autoplay
            playsinline
          />
          <span> {{ item.Phase }}<br></span>
          <span> จุดติดตั้ง: {{ item.Camera_Desc }}</span>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col
          v-for="(item, index) in stopline.slice(0,2)"
          :key="(index +2)"
          lg="4"
          md="6"
          sm="12"
        >
          <b-card
            style=" background-color: rgba(0, 0, 0, 0.5);"
          >
            <video
              :id="'stopline' + (index)"
              style="width:100%;"
              muted
              autoplay
              playsinline
            />
            <span> {{ item.Phase }}<br></span>
            <span> จุดติดตั้ง: {{ item.Camera_Desc }}</span>
          </b-card>
        </b-col>
      <!-- ไฟจราจรขวา -->
      <!-- <b-col
        lg="1"
        md="12"
        sm="12"
      >
        <b-img
          style="margin-top: 20px;"
          height="150"
          src="@/assets/images/icons/triffic/redlight.png"
        />
      </b-col> -->
      </b-row>
      <b-row align-h="center">
        <b-col
          v-for="(item, index) in stopline.slice(2,3)"
          :key="(index +4)"
          lg="4"
          md="6"
          sm="12"
        >
          <b-card
            style=" background-color: rgba(0, 0, 0, 0.5);"
          >
            <video
              :id="'stopline' + (index+2)"
              style="width:100%;"
              muted
              autoplay
              playsinline
            />
            <span> {{ item.Phase }}<br></span>
            <span> จุดติดตั้ง: {{ item.Camera_Desc }}</span>
          </b-card>
        </b-col>
        <b-col
          lg="4"
          md="6"
          sm="12"
        />
      </b-row>
      <b-row align-h="between">
        <b-col
          v-for="(item, index) in count.slice(2,3)"
          :key="(index+5)"
          lg="3"
          md="6"
          sm="12"
        >
          <video
            :id="'count' + (index+2)"
            style="width:100%;"
            muted
            autoplay
            playsinline
          />
          <span> {{ item.Type }}<br></span>
          <span> จุดติดตั้ง: {{ item.Camera_Desc }}</span>
        </b-col>
      <!-- ไฟจราจรข้างล่าง -->
      <!-- <b-col
        lg="9"
        md="12"
        sm="12"
      >
        <b-img
          style="margin-top: -15px;"
          height="150"
          src="@/assets/images/icons/triffic/redlight.png"
        />
      </b-col> -->
      </b-row>
    </b-card>
    <!-- 4แยก 4กล้อง-->
    <b-card
      v-else-if="check === 4 && countPhase === 4"
      class="hero"
      style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;"
    >
      <b-row
        align-h="between"
        class="hero31"
      >
        <b-col
          v-for="(item, index) in count.slice(0,2)"
          :key="index"
          lg="4"
          md="6"
          sm="12"
        >
          <video
            :id="'count' + (index)"
            style="width:100%;"
            muted
            autoplay
            playsinline
          />
          <span> {{ item.Phase }}<br></span>
          <span> จุดติดตั้ง: {{ item.Camera_Desc }}</span>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col
          v-for="(item, index) in count.slice(0,2)"
          :key="(index +2)"
          lg="4"
          md="6"
          sm="12"
        >
          <b-card
            style=" background-color: rgba(0, 0, 0, 0.0);"
          >
            <video
              :id="'count1' + (index)"
              style="width:100%;"
              muted
              autoplay
              playsinline
            />
            <span> <br></span>
            <span> <br></span>
          </b-card>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col
          v-for="(item, index) in count.slice(2,4)"
          :key="(index +4)"
          lg="4"
          md="6"
          sm="12"
        >
          <b-card
            style=" background-color: rgba(0, 0, 0, 0.0);"
          >
            <video
              :id="'count1' + (index+2)"
              style="width:100%;"
              muted
              autoplay
              playsinline
            />
            <span> <br></span>
            <span> <br></span>
          </b-card>
        </b-col>
      </b-row>
      <b-row align-h="between">
        <b-col
          v-for="(item, index) in count.slice(2,4)"
          :key="(index+6)"
          lg="4"
          md="6"
          sm="12"
        >
          <video
            :id="'count' + (index+2)"
            style="width:100%;"
            muted
            autoplay
            playsinline
          />
          <span> {{ item.Phase }}<br></span>
          <span> จุดติดตั้ง: {{ item.Camera_Desc }}</span>
        </b-col>
      </b-row>
    </b-card>
    <!-- 4แยก -->
    <b-card
      v-if="check === 4 && countPhase > 4"
      class="hero"
      style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;"
    >
      <b-row
        align-h="between"
        class="hero3"
      >
        <b-col
          v-for="(item, index) in count.slice(0,2)"
          :key="index"
          lg="3"
          md="6"
          sm="12"
        >
          <video
            :id="'count' + (index)"
            style="width:100%;"
            muted
            autoplay
            playsinline
          />
          <span> {{ item.Phase }}<br></span>
          <span> จุดติดตั้ง: {{ item.Camera_Desc }}</span>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col
          v-for="(item, index) in stopline.slice(0,2)"
          :key="(index +2)"
          lg="4"
          md="6"
          sm="12"
        >
          <b-card
            style=" background-color: rgba(0, 0, 0, 0.5);"
          >
            <video
              :id="'stopline' + (index)"
              style="width:100%;"
              muted
              autoplay
              playsinline
            />
            <span> {{ item.Phase }}<br></span>
            <span> จุดติดตั้ง: {{ item.Camera_Desc }}</span>
          </b-card>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col
          v-for="(item, index) in stopline.slice(2,4)"
          :key="(index +4)"
          lg="4"
          md="6"
          sm="12"
        >
          <b-card
            style=" background-color: rgba(0, 0, 0, 0.5);"
          >
            <video
              :id="'stopline' + (index+2)"
              style="width:100%;"
              muted
              autoplay
              playsinline
            />
            <span> {{ item.Phase }}<br></span>
            <span> จุดติดตั้ง: {{ item.Camera_Desc }}</span>
          </b-card>
        </b-col>
      </b-row>
      <b-row align-h="between">
        <b-col
          v-for="(item, index) in count.slice(2,4)"
          :key="(index+6)"
          lg="3 "
          md="6"
          sm="12"
        >
          <video
            :id="'count' + (index+2)"
            style="width:100%;"
            muted
            autoplay
            playsinline
          />
          <span> {{ item.Phase }}<br></span>
          <span> จุดติดตั้ง: {{ item.Camera_Desc }}</span>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable global-require */
import Hls from 'hls.js'
import {
  BRow, BCol, BCard,
  // BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    // BImg,
  },
  data() {
    return {
      count: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      itemsCount: [],
      stopline: [],
      check: '',
      countPhase: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.checkPhase()
    this.getCamTraffic()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.checkPhase()
      this.getCamTraffic()
    }, 300000)
  },
  methods: {
    checkPhase() {
      axios
        .post('/checkPhaseTraffic', { wid: this.$route.query.wid })
        .then(response => {
          this.check = response.data[0].PhaseNo
          this.countPhase = response.data[0].CountPhase
          console.log(this.countPhase)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCamTraffic() {
      axios
        .post('/getCamTrafficDetail', { wid: this.$route.query.wid })
        .then(response => {
          response.data.forEach(value => {
            if (value.Type === 'Count') {
              this.count.push({ RTSP_URL: value.RTSP_URL, Camera_Desc: value.Camera_Desc })
            }
            if (value.Type === 'StopLine') {
              this.stopline.push({ RTSP_URL: value.RTSP_URL, Camera_Desc: value.Camera_Desc })
            }
          })
          if (this.check < 4) {
            setTimeout(() => this.count.forEach(() => {
              this.for3()
            }), 500)
          } else {
            setTimeout(() => this.count.forEach(() => {
              this.for4()
            }), 500)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    for3() {
      setTimeout(() => this.count.slice(0, 2).forEach((value, i) => {
        this.stream(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.stopline.slice(0, 2).forEach((value, i) => {
        this.stream1(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.stopline.slice(2, 3).forEach((value, i) => {
        this.stream2(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.count.slice(2, 3).forEach((value, i) => {
        this.stream3(value.RTSP_URL, i)
      }), 500)
    },
    stream(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#count${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream1(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#stopline${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream2(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#stopline${i + 2}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream3(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#count${i + 2}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    for4() {
      setTimeout(() => this.count.slice(0, 2).forEach((value, i) => {
        this.stream4(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.stopline.slice(0, 2).forEach((value, i) => {
        this.stream5(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.stopline.slice(2, 4).forEach((value, i) => {
        this.stream6(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.count.slice(2, 4).forEach((value, i) => {
        this.stream7(value.RTSP_URL, i)
      }), 500)
    },
    stream4(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#count${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream5(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#stopline${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream6(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#stopline${i + 2}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream7(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#count${i + 2}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
  },
}
</script>

<style >
.chart1{
  display: block;
  margin-left: auto;
  margin-right: auto;
    }
.hero::before {
    content: "";
    background: url(~@/assets/images/traffic/Jucntion.png) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 10px;
    top : 20px;
    background-size: cover;
    width: 98%;
    height: 95%;
    opacity: 0.6;
  }
  .hero1::before {
    content: "";
    background: url(~@/assets/images/traffic/traffic3-2.png) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 10px;
    top : 20px;
    background-size: cover;
    width: 95%;
    height: 90%;
    opacity: 0.6;
  }
  .hero2::before {
    content: "";
    background: url(~@/assets/images/icons/traffic/Junction-3.png) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 10px;
    top : 10px;
    background-size: cover;
    width: 95%;
    height: 90%;
    opacity: 1.0;
  }
  .hero3::before {
    content: "";
    background: url(~@/assets/images/icons/traffic/Junction-4.png) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 10px;
    top : 10px;
    background-size: cover;
    width: 95%;
    height: 90%;
    opacity: 1.0;
  }
  .hero31::before {
    content: "";
    background: url(~@/assets/images/icons/traffic/Junction-4-4.png) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 10px;
    top : 10px;
    background-size: cover;
    width: 100%;
    height: 100%;
    opacity: 1.0;
  }

</style>
